import { render } from "./CustomizationShareDropdown.vue?vue&type=template&id=db1fd20a&scoped=true"
import script from "./CustomizationShareDropdown.vue?vue&type=script&lang=js"
export * from "./CustomizationShareDropdown.vue?vue&type=script&lang=js"

import "./CustomizationShareDropdown.vue?vue&type=style&index=0&id=db1fd20a&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db1fd20a"]])

export default __exports__